import React from "react";
import { func, string, bool, shape } from "prop-types";
import moment from "moment";
import { monthNames, getDurationBetween } from "../../../../helpers/index";

const WorkHistoryCard = ({
  workHistory: {
    id,
    title = "",
    companyName,
    fromMonth = "",
    fromYear = "",
    toMonth = "",
    toYear = "",
    currentlyWorkHere = false,
    description = "",
  },
  onEdit,
  onRemove,
}) => {
  const thisMonth = moment().format("M");
  const thisYear = moment().format("YYYY");
  const toDateDisplay = currentlyWorkHere
    ? "present"
    : `${monthNames[toMonth]} ${toYear}`;
  return (
    <div className="col-12 col-sm-8 col-lg-7 justify-content-center my-2 p-0 section-body text-bluishGray">
      <header className="p-1">
        <h3 className="mb-hf fontSize-24 text-spacedOut">{title}</h3>
        <h4 className="fontSize-16 mb-0">{companyName}</h4>
      </header>
      <div className="p-1" style={{ background: "rgba(33, 150, 243, 0.1)" }}>
        <p className="mb-hf text-spacedOut font-weight-bolder">
          {monthNames[fromMonth]} {fromYear} - {toDateDisplay}
        </p>
        <p className="fontSize-12 text-spacedOut mb-0">
          {currentlyWorkHere
            ? getDurationBetween([fromYear, fromMonth], [thisYear, thisMonth])
            : getDurationBetween([fromYear, fromMonth], [toYear, toMonth])}
        </p>
        {description && (
          <p className="mt-1 mb-0 text-spacedOut">{description}</p>
        )}
      </div>
      <div className="d-flex justify-content-end p-1">
        <button className="btn btn-outline-dark" onClick={() => onEdit(id)}>
          Edit
        </button>
        <button
          className="btn btn-outline-dark ml-1"
          onClick={() => onRemove(id)}
        >
          Remove
        </button>
      </div>
    </div>
  );
};

WorkHistoryCard.propTypes = {
  workHistory: shape({
    id: string.isRequired,
    title: string,
    companyName: string,
    fromMonth: string,
    fromYear: string,
    toMonth: string,
    toYear: string,
    currentlyWorkHere: bool,
    description: string,
  }).isRequired,
  onEdit: func.isRequired,
  onRemove: func.isRequired,
};

export default WorkHistoryCard;
